import type { GetApiCourses200ContentItemSectionsItemLecturesItem } from './getApiCourses200ContentItemSectionsItemLecturesItem';

export type GetApiCourses200ContentItemSectionsItem = {
  id: number;
  lectures: GetApiCourses200ContentItemSectionsItemLecturesItem[];
  title: string;
};
